export const AUTH_TOKEN = 'razzilAdmTknx';



// WEBPACK FOOTER //
// ./src/util/constants.js